import React from 'react';

import BackgroundImage from '../../../components/BackgroundImage';

const background = require('../../../assets/images/404.jpg');

export const NotFound = () => (
  <div className="staff-home">
    <BackgroundImage src={background} className="staff-home-bg" alt="bg-image">
      <div className="admin-wrapper">
        <div className="clubs-picker-layout not-found-page">
          <h1>404</h1>
          <h2>Looks like you missed the page!</h2>
          <h3>The page you are looking for was moved, removed, renamed or might never existed.</h3>
        </div>
      </div>
    </BackgroundImage>
  </div>
);
